import BaseDataService from "./BaseDataService";
import http from "../http-common";
class ReportDataService extends BaseDataService {
  constructor(name) {
    super(name)
    this.moduleName = 'counts-hit-managedservice'
  }

  get(payload) {
    if (payload == null) {
      return http.get(`/${this.moduleName}`);
    } else {
      return http.get(`/${this.moduleName}`, { params: payload });

    }
  }

  // counts-hit-managedservice?date_start=2023-06-03&date_end=2023-06-07&client_name=paxel
}

export default new ReportDataService();